module.exports = __webpack_public_path__ + "media/images/flags/ch-bb13e8d79d5d8e5f91861f56734666c6.svg";